import styled from 'styled-components';

const LinkIconButton = styled.a`
  display: inline-block;
  font-size: ${(p) => (p.smaller ? '2rem' : '2.5rem')};
  text-decoration: none;
  list-style: none;
  outline: none;
  transition: 0.2s ease-in-out;
  color: ${(p) => p.theme.accent.secondary};
  cursor: pointer;

  &:hover {
    filter: saturate(250%);
  }

  &:active {
    filter: brightness(130%);
  }

  @media screen and (max-width: 768px) {
    font-size: ${(p) => (p.smaller ? '1.6rem' : '2.0rem')};
  }

  @media screen and (max-height: 600px) {
    font-size: ${(p) => (p.smaller ? '1.4rem' : '1.8rem')};
  }

  @media screen and (max-height: 600px) and (min-width: 900px) {
    font-size: ${(p) => (p.smaller ? '1.8rem' : '2.2rem')};
  }
`;

export default LinkIconButton;
